import { memo } from "react";
import { useLocation, createSearchParams, useInRouterContext, useNavigate, useSearchParams } from "react-router-dom";
import {
   alertsPlugin,
   BetterHtmlProvider as BetterHtmlProviderComponent,
   localStoragePlugin,
   reactRouterDomPlugin,
   type BetterHtmlPlugin,
} from "react-better-html";

import { disableLocalStorageEncryption } from "../../constants/app";
import { config } from "../../constants/betterHtml";

const plugins: BetterHtmlPlugin[] = [
   reactRouterDomPlugin({
      useLocation,
      createSearchParams,
      useInRouterContext,
      useNavigate,
      useSearchParams,
   }),
   alertsPlugin(),
   localStoragePlugin({
      encryption: {
         enabled: !disableLocalStorageEncryption,
         secretKey: import.meta.env.VITE_ENCRYPTION_SECRET_KEY,
         iv: import.meta.env.VITE_ENCRYPTION_IV,
      },
   }),
];

type BetterHtmlProviderProps = {
   children?: React.ReactNode;
};

function BetterHtmlProvider({ children }: BetterHtmlProviderProps) {
   return (
      <BetterHtmlProviderComponent config={config} plugins={plugins}>
         {children}
      </BetterHtmlProviderComponent>
   );
}

export default memo(BetterHtmlProvider);
